<template>
  <div
    v-if="show"
    id="dev-LoadingOverlay"
    class="loading-overlay"
  >
    <BSpinner class="loading-spinner" />
    <p>{{ $t('map_navigation.loading') }}</p>
  </div>
</template>

<script>
  export default {
    name: 'LoadingOverlay',
    props: {
      show: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped lang="scss">
  .loading-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.95);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 104;

    p {
      margin-top: 16px;
      color: #424242;
      font-size: 16px;
    }
  }

  .loading-spinner {
    width: 48px;
    height: 48px;
  }
</style>
